import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import Feed from "./pages/Feed";
import Inputs from "./pages/Inputs";
import Favorites from "./pages/Favorites";
import ExportStudio from "./pages/ExportStudio";
import XCallback from "./pages/XCallback";
import Layout from "./components/Layout";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0D12]">
        <Loader2 className="w-7 h-7 text-emerald-400 animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function Inner() {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/x/callback" element={<XCallback />} />
      <Route path="/feed" element={<Protected><Feed /></Protected>} />
      <Route path="/inputs" element={<Protected><Inputs /></Protected>} />
      <Route path="/favorites" element={<Protected><Favorites /></Protected>} />
      <Route path="/export" element={<Protected><ExportStudio /></Protected>} />
      <Route path="*" element={<Navigate to="/feed" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App pf-noise">
      <BrowserRouter>
        <AuthProvider>
          <Inner />
          <Toaster position="top-right" theme="dark" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
